import { render, staticRenderFns } from "./InputBig.vue?vue&type=template&id=8da9da78&scoped=true&"
import script from "./InputBig.vue?vue&type=script&lang=js&"
export * from "./InputBig.vue?vue&type=script&lang=js&"
import style0 from "./InputBig.vue?vue&type=style&index=0&id=8da9da78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da9da78",
  null
  
)

export default component.exports